import React from "react"
import { Link } from "gatsby"
import Highlighter from "react-highlight-words"

class knowledgeSearch extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      posts: this.props.posts,
      value: "",
      show: false,
      location: "",
    }
    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }
  handleChange(event) {
    if (event.target.value.length !== 0) {
      this.setState({ value: event.target.value, show: true })
    } else {
      this.setState({ value: "", show: false })
    }
  }

  handleSubmit(event) {
    if (this.state.value !== "") {
      window.location.href = `/knowledge-base/search?=${this.state.value}`
      event.preventDefault()
    } else {
      alert("Search field is empty")
      event.preventDefault()
    }
  }
  render() {
    const { posts } = this.state
    const post = posts.filter(({ node }) => {
      const queryParam = node.body
        ? node.body.toLowerCase().includes(this.state.value)
        : node.discription.toLowerCase().includes(this.state.value)
      return node.title.toLowerCase().includes(this.state.value) || queryParam
    })
    // console.log(this.state.value)
    return (
      <div className="searchbar mt-5">
        <div className="container">
          <form onSubmit={this.handleSubmit}>
            <div className="form-row">
              <div className="col-md-6 form-group mx-auto">
                <div className="searchbarbox">
                  <input
                    className="form-control form-control-lg"
                    placeholder="Search Knowledge Base"
                    value={this.state.value}
                    onChange={this.handleChange}
                  />
                  <button
                    className="btn btn-search btn-primary mt-4"
                    type="submit"
                  >
                    Search
                  </button>
                </div>
                <div
                  className={`result ${this.state.show ? "d-block" : "d-none"}`}
                >
                  <ul className="list-unstyled text-left mb-0" key={post.index}>
                    {post.map((data, index) => {
                      const category = data.node.categories.filter(
                        item => item.title
                      )
                      return (
                        <>
                          {category.map((cat, idx) => (
                            <li key={idx}>
                              <Link
                                to={`/knowledge-base/${cat.slug.current}/${data.node.slug.current}/`}
                              >
                                {data.node.title}
                              </Link>
                              <p>
                                <Link
                                  to={`/knowledge-base/${cat.slug.current}/${data.node.slug.current}/`}
                                >
                                  <Highlighter
                                    searchWords={[this.state.value]}
                                    autoEscape={true}
                                    textToHighlight={data.node.metaDescription.slice(
                                      0,
                                      200
                                    )}
                                  />
                                  ...
                                </Link>
                              </p>
                            </li>
                          ))}
                        </>
                      )
                    })}
                    <li>No Results Found</li>
                  </ul>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    )
  }
}

export default knowledgeSearch
